import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ceb3616"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "swipe-arrows" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-long-arrow-alt-left" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["aria-label"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-long-arrow-alt-right" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prev && _ctx.prev(...args))),
      class: "circle",
      "data-testid-swipe-arrow-prev": "",
      "aria-label": _ctx.$t('general.previous')
    }, _hoisted_4, 8, _hoisted_2),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args))),
      class: "circle",
      "data-testid-swipe-arrow-next": "",
      "aria-label": _ctx.$t('general.next')
    }, _hoisted_7, 8, _hoisted_5)
  ]))
}